import { createCachedSelector } from 're-reselect';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data) => {
    const orders = data || [];
    return {
      orders
    };
  }
)({
  keySelector: (data, storeKey) => storeKey.join('#')
});

const useAccountOrders = () => {
  const { accountId } = useAccount();

  const storeKey = ['account-orders', accountId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchAccountOrders({ accountId }), {
    enabled: !!accountId,
    cacheTime: 0,
    select: (accountOrdersData) => selector(accountOrdersData, storeKey)
  });

  const { orders } = useMemo(() => {
    const { orders: rawOrders } = data || {};
    return {
      orders: rawOrders
    };
  }, [data]);

  return {
    isLoading,
    orders
  };
};

export default useAccountOrders;
